import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useSharedSafariContext } from "provider/ShareSafariProvider";

import StepForm1 from "./organizesteps/StepForm1";
import StepForm2 from "./organizesteps/StepForm2";
import StepForm3 from "./organizesteps/StepForm3";
import apiCall from "components/Api/api";
import { handleError } from "components/Api/handleError";
import { useNavigate } from "react-router-dom";
import { useToast } from "provider/ToastProvider";
import { useAuth } from "provider/AuthContext";
import { todayIST } from "components/Api/common";
import { initialOrganizeSafari } from "Data/sharedSafari";

const OrganizeSharedSafariModal = () => {
  const { showSuccessToast } = useToast();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { toggleOragnize, organizeSafari, step, noOfStep, sharedSafariDispatch } = useSharedSafariContext();
  const [loading, setLoading] = useState(false);


  const validateStep1 = () => {
    const errors = {
      share_safari_title: '',
      park_id: '',
      start_date: '',
      end_date: '',
      no_of_safari: '',
    };

    if (!organizeSafari?.share_safari_title?.trim()) {
      errors.share_safari_title = "Title is required";
    }

    if (!organizeSafari?.park_id) {
      errors.park_id = "Please select a park";
    }

    if (!organizeSafari?.start_date) {
      errors.start_date = "Start date is required";
    } else if (organizeSafari.start_date < todayIST) {
      errors.start_date = "Start date cannot be before today";
    }

    if (!organizeSafari?.end_date) {
      errors.end_date = "End date is required";
    } else if (
      organizeSafari?.start_date &&
      organizeSafari.end_date <= organizeSafari.start_date
    ) {
      errors.end_date = "End date must be after start date";
    }

    // Dispatch the errors
    sharedSafariDispatch({
      type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
      payload: errors,
    });

    // If all error values are empty, the form is valid
    return Object.values(errors).every((msg) => msg === "");
  };


  const validateStep2 = () => {
    const errors = {
      share_safari_agenda_id: '',
      stay_category_id: '',
      estimate_price_min: '',
      estimate_price_max: '',
      total_seat: '',
      share_seat: '',
    };

    const {
      share_safari_agenda_id,
      stay_category_id,
      estimate_price_min,
      estimate_price_max,
      total_seat,
      share_seat,
    } = organizeSafari;

    // Validate agenda (theme)
    if (!share_safari_agenda_id) {
      errors.share_safari_agenda_id = "Please select a theme";
    }

    // Validate stay category
    if (!stay_category_id) {
      errors.stay_category_id = "Please select a stay category";
    }

    // Validate estimate_price_min
    if (!estimate_price_min || estimate_price_min <= 0) {
      errors.estimate_price_min = "Min price must be greater than 0";
    } else if (estimate_price_max && estimate_price_min >= estimate_price_max) {
      errors.estimate_price_min = "Min must be less than Max price";
    }

    // Validate estimate_price_max
    if (!estimate_price_max || estimate_price_max <= 0) {
      errors.estimate_price_max = "Max price must be greater than 0";
    } else if (estimate_price_min && estimate_price_max <= estimate_price_min) {
      errors.estimate_price_max = "Max must be greater than Min price";
    }

    // Validate total_seat
    if (!total_seat || isNaN(total_seat) || parseInt(total_seat) <= 0) {
      errors.total_seat = "Total seat is required and must be greater than 0";
    }

    // Validate share_seat
    if (!share_seat || isNaN(share_seat) || parseInt(share_seat) <= 0) {
      errors.share_seat = "Please select valid share seats";
    } else if (parseInt(share_seat) >= parseInt(total_seat)) {
      errors.share_seat = "Share seats must be less than total seats";
    }

    // Dispatch the errors
    sharedSafariDispatch({
      type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
      payload: errors,
    });

    // Return validation result
    return Object.values(errors).every((msg) => msg === "");
  };

  const validateStep3 = () => {
    const errors = {
      shared_safari_image: '',
      safari_plan: '',
    };

    const { safari_plan } = organizeSafari;

    // Validate safari plan
    if (!safari_plan || safari_plan.trim() === "") {
      errors.safari_plan = "Safari plan is required";
    }

    // Dispatch the errors
    sharedSafariDispatch({
      type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
      payload: errors,
    });

    // Return whether the step is valid
    return Object.values(errors).every((msg) => msg === "");
  };






  const stepValidators = [validateStep1, validateStep2, validateStep3];

  const handleNext = () => {
    if (Number(step) < noOfStep && stepValidators[Number(step) - 1]()) {
      let nextStep = Number(step) + 1;
      sharedSafariDispatch({
        type: "ORGANIZE_SF_SET_STEP",
        payload: nextStep,
      });
    }
  };
  const handleBack = () => {
    if (step > 1) {
      let nextStep = Number(step) - 1;
      sharedSafariDispatch({
        type: "ORGANIZE_SF_SET_STEP",
        payload: nextStep,
      });
    }
  };

  const handleClose = () => {
    if (organizeSafari?.slug) {
      sharedSafariDispatch({
        type: "UPDATE_ORGANIZE_SHARE_SAFARI",
        payload: initialOrganizeSafari,
      });
      sharedSafariDispatch({
        type: "SHARED_SAFARI_PAGE_INDEX",
        payload: 1,
      });
      sharedSafariDispatch({
        type: "ORGANIZE_SF_SET_STEP",
        payload: 1,
      });
      sharedSafariDispatch({ type: "ORGANIZE_SHARE_SAFARI_TOGGLE", payload: false });
    } else {
      sharedSafariDispatch({ type: "ORGANIZE_SHARE_SAFARI_TOGGLE", payload: false });
    }

  }

  const renderStepForm = () => {
    switch (step) {
      case 1:
        return <StepForm1 />;
      case 2:
        return <StepForm2 />;
      case 3:
        return <StepForm3 />;
      default:
        return null;
    }
  };
  const validateSafariForm = (form) => {
    const errors = {
      share_safari_title: "",
      park_id: "",
      start_date: "",
      end_date: "",
      no_of_safari: "",
      share_safari_agenda_id: "",
      stay_category_id: "",
      estimate_price_min: "",
      estimate_price_max: "",
      total_seat: "",
      share_seat: "",
    };

    const today = new Date().setHours(0, 0, 0, 0);

    if (!form?.share_safari_title?.trim()) {
      errors.share_safari_title = "Title is required";
    }

    if (!form?.park_id) {
      errors.park_id = "Please select a park";
    }

    if (!form?.start_date) {
      errors.start_date = "Start date is required";
    } else if (new Date(form.start_date).setHours(0, 0, 0, 0) < today) {
      errors.start_date = "Start date cannot be before today";
    }

    if (!form?.end_date) {
      errors.end_date = "End date is required";
    } else if (
      form?.start_date &&
      new Date(form.end_date).setHours(0, 0, 0, 0) <= new Date(form.start_date).setHours(0, 0, 0, 0)
    ) {
      errors.end_date = "End date must be after start date";
    }

    if (!form?.no_of_safari) {
      errors.no_of_safari = "Please enter number of safaris";
    }

    if (!form?.share_safari_agenda_id) {
      errors.share_safari_agenda_id = "Please select a safari agenda";
    }

    if (!form?.stay_category_id) {
      errors.stay_category_id = "Please select a stay category";
    }

    if (form?.estimate_price_min === undefined || form.estimate_price_min === "") {
      errors.estimate_price_min = "Please enter minimum estimated price";
    }

    if (form?.estimate_price_max === undefined || form.estimate_price_max === "") {
      errors.estimate_price_max = "Please enter maximum estimated price";
    } else if (
      form?.estimate_price_min !== undefined &&
      form?.estimate_price_max < form?.estimate_price_min
    ) {
      errors.estimate_price_max = "Maximum price cannot be less than minimum price";
    }

    if (!form?.total_seat) {
      errors.total_seat = "Please enter total seats";
    }

    if (!form?.share_seat) {
      errors.share_seat = "Please enter shared seats";
    }

    // If all errors are empty strings, form is valid
    const isValid = Object.values(errors).every((msg) => msg === "");

    return { isValid, errors };
  };

  const handleSubmit = async (e) => {

    if (Number(step) !== noOfStep) return;
    e.preventDefault();
    setLoading(true);

    try {
      const { isValid, errors } = validateSafariForm(organizeSafari);
  

      if (!isValid) {
        // Dispatch or set error state to show in the UI
        sharedSafariDispatch({
          type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
          payload: errors,
        });

        return;
      }

      const formData = new FormData();

      // Dynamically append all non-null/non-undefined values
      Object.entries(organizeSafari).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          if (key === "slug") {
            // Skip slug entirely
            return;
          }

          if (key === "shared_safari_image") {
            // Append only if it's a File object (i.e., user uploaded new file)
            if (value instanceof File) {
              formData.append(key, value);
            }
            return;
          }

          // Append all other valid fields
          formData.append(key, value);
        }
      });


      const url = organizeSafari?.slug ? `sharesafari/${organizeSafari?.slug}/update` : `sharesafari/organize-safari`
      // return
      const response = await apiCall({
        url: url,
        method: "POST",
        data: formData,
      });
      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
      const apiData = response.data;
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        const firstKey = Object.keys(apiData.errors)[0];
        return sharedSafariDispatch({
          type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
          payload: apiData.errors[firstKey][0],
        });
      }
      if (apiData?.status === 1) {
        showSuccessToast(apiData?.message);
        sharedSafariDispatch({
          type: "UPDATE_ORGANIZE_SHARE_SAFARI",
          payload: initialOrganizeSafari,
        });
        sharedSafariDispatch({
          type: "UPDATE_SHARED_SAFARI_LISTING",
          payload: true,
        });
        sharedSafariDispatch({
          type: "SHARED_SAFARI_PAGE_INDEX",
          payload: 1,
        });
        sharedSafariDispatch({
          type: "ORGANIZE_SF_SET_STEP",
          payload: 1,
        });
        handleClose();

      }
    } catch (error) {
      console.error("Cover photo upload error:", error.message);
      handleError(error, logout, navigate);
    } finally {
      setLoading(false);
    }
  };


  return (
    <Modal show={toggleOragnize} onHide={handleClose} centered backdrop="static" >
      <Modal.Header className="justify-content-center" closeButton>
        <h2 className="modal-title fs-5">Organize a Shared Safari</h2>
      </Modal.Header>
      <Modal.Body className="px-3 pt-0">

        <div className="py-3 px-2">
          <Container fluid="lg">
            <div>
              {renderStepForm()}
            </div>
            <Row>
              <Col lg={12} className="margin-remove pt-3">
                <div className="creat-safri d-flex justify-content-end">

                  {Number(step) === 1 ? (
                    <button
                      type="button"
                      className="cancel_btn_safari"
                      onClick={handleClose}
                      disabled={loading}
                    >
                      Cancel
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="cancel_btn_safari"
                      onClick={handleBack}
                      disabled={loading}
                    >
                      back
                    </button>
                  )}


                  {(Number(step) < noOfStep) ? (
                    <button
                      type="button"
                      className="btn safari_create_next font_set w-auto ms-2 next_screen"
                      onClick={handleNext}
                      disabled={loading}
                    >
                      Next
                    </button>
                  ) : (
                    <button
                      onClick={handleSubmit}
                      className="btn safari_create_next font_set w-auto ms-2 next_screen"
                      disabled={loading}
                    >
                      {organizeSafari?.slug ? 'Update' : 'Create'}
                    </button>
                  )}

                </div>

              </Col>
            </Row>


            <div className="dots-container text-center mt-3">
              {[1, 2, 3].map((dotStep) => (
                <span
                  key={dotStep}
                  className={`dot ${step === dotStep ? "active" : ""}`}
                  onClick={() => {
                    // Allow jump only to steps <= current step
                    if (dotStep <= step) {
                      let targetStep = dotStep;
                      sharedSafariDispatch({
                        type: "ORGANIZE_SF_SET_STEP",
                        payload: targetStep,
                      });
                    }
                  }}
                ></span>
              ))}
            </div>

          </Container>
        </div>




      </Modal.Body>

    </Modal>
  );
}

export default OrganizeSharedSafariModal;
